import { render, staticRenderFns } from "./ConfirmReg.vue?vue&type=template&id=f72051f8&"
import script from "./ConfirmReg.vue?vue&type=script&lang=js&"
export * from "./ConfirmReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports